import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

let _cache = null;
let _inflight = null;

/**
 * Returns a Set of country NAMES that are NOT 'active' on the platform (i.e. should be filtered out).
 * On first mount it fetches /api/platform/countries; cached for the session.
 * If the request fails or hasn't returned yet, the set is empty (so dropdowns show everything — fail-open).
 */
export function useInactiveCountries() {
  const [inactive, setInactive] = useState(() => _cache || new Set());

  useEffect(() => {
    if (_cache) { setInactive(_cache); return; }
    if (!_inflight) {
      _inflight = axios.get(`${API_URL}/api/platform/countries`).then(res => {
        const hidden = res.data?.hidden || [];
        const disabled = res.data?.disabled || [];
        _cache = new Set([...hidden, ...disabled].map(c => (c || '').toLowerCase()));
        return _cache;
      }).catch(() => new Set());
    }
    _inflight.then((s) => setInactive(s));
  }, []);

  return inactive;
}

export function isCountryAllowed(countryName, inactiveSet) {
  if (!inactiveSet || inactiveSet.size === 0) return true;
  return !inactiveSet.has((countryName || '').toLowerCase());
}
